import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import {
  PATH_CAMPAIGNS,
  PATH_CAMPAIGNS_UID,
} from "~/modules/campaign/constants";
import { LicenseFeatureName } from "~/modules/license/models/LicenseFeatureName.enum";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_CAMPAIGNS,
    component: () => import("~/modules/campaign/views/CampaignsPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) =>
        can(ACLRoles.CAN_READ_DEVICE) &&
        useLicenseStore().isLicenseFeatureEnabled(
          LicenseFeatureName.CAMPAIGN_MANAGEMENT_STATIC,
        ),
      breadcrumb: BREADCRUMBS.CAMPAIGN,
    },
  },
  {
    path: PATH_CAMPAIGNS_UID,
    component: () =>
      import("~/modules/campaign/views/CampaignOperationMgrDetailPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) =>
        can(ACLRoles.CAN_READ_DEVICE) &&
        useLicenseStore().isLicenseFeatureEnabled(
          LicenseFeatureName.CAMPAIGN_MANAGEMENT_STATIC,
        ),
      breadcrumb: BREADCRUMBS.CAMPAIGN,
    },
  },
];

export default routes;
